import React from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Icon } from '@iconify/react'

type FilterType = 'all' | 'out' | 'in'

type Props = {
  value: FilterType
  onChange: (value: FilterType) => void
}

const StatusFilter: React.FC<Props> = ({ value, onChange }) => {
  const navigate = useNavigate()
  const { teamId } = useParams()
  const [searchParams] = useSearchParams()
  const teamName = searchParams.get('name') ?? ''

  const filterLabels: Record<FilterType, string> = {
    all: 'All',
    out: 'Out',
    in: 'In',
  }

  const filterOrder: FilterType[] = ['all', 'out', 'in']
  
  const handleToggle = () => {
    const currentIndex = filterOrder.indexOf(value)
    const nextIndex = (currentIndex + 1) % filterOrder.length
    onChange(filterOrder[nextIndex])
  }

  const handleGridClick = () => {
    if (teamId) {
      navigate(`/team/${teamId}/greenhouse?name=${encodeURIComponent(teamName)}`)
    }
  }

  return (
    <div className='flex items-center gap-2'>
      <button
        onClick={handleGridClick}
        className='p-2 text-sm font-medium rounded-lg border border-blue-700 bg-blue-700 text-white hover:bg-blue-800 transition-colors flex items-center justify-center'
        title='Grid view'
      >
        <Icon icon="lucide:grid-3x3" width={20} />
      </button>
      <button
        onClick={handleToggle}
        className='px-4 py-1.5 text-sm font-medium rounded-lg border border-blue-700 bg-blue-700 text-white hover:bg-blue-800 transition-colors'
      >
        {filterLabels[value]}
      </button>
    </div>
  )
}

export default StatusFilter
